// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f03ccef0","239":"f5158508","455":"43c9fa85"}[chunkId] + ".chunk.js";
};